<template>
  <div v-if="!loading" class="cta-box">
    <div v-if="boxes" class="boxes">
      <a
        v-for="(box, index) in boxes"
        :key="index"
        @click="selectBox(box)"
        class="linkbox"
      >
        <img :src="box.image" width="768" height="768" />
        <h2>{{ box.title }}</h2>
        <p class="desc">{{ box.description }}</p>
        <h3 v-if="box.shop_product">{{ box.shop_product.price }}€</h3>
      </a>
    </div>
  </div>
  <div v-else class="loading">
    <Preloader :size="90" />
  </div>
</template>
<script>
import axios from "axios";
import Preloader from "@/components/Preloader.vue";

export default {
  data() {
    return {
      boxes: [],
      loading: true,
    };
  },

  components: {
    Preloader,
  },

  props: {
    type: String,
  },

  methods: {
    fetchBoxes() {
      axios
        .get(window["wpApiSettings"].root + "menaboh/v1/box")
        .then(
          (response) => ((this.boxes = response.data), (this.loading = false))
        );
    },

    selectBox(box) {
      this.loading = true;
      const b = JSON.stringify(box);
      localStorage.setItem("menaboh_box", b);
      localStorage.setItem("menaboh_step", 2);
      this.$store.commit("goToStep", 2);
      document.body.classList.add("fixed");
    },
  },

  mounted() {
    this.fetchBoxes();
    localStorage.removeItem("menaboh_step");
    localStorage.removeItem("menaboh_box");
    localStorage.removeItem("menaboh_size");
    localStorage.removeItem("menaboh_selected");
    localStorage.removeItem("menaboh_keywords");
  },
};
</script>
<style scoped lang="scss">

.loading {
  height: 100%;
  display: flex;
  align-items: center;
}

.desc {
  line-height: 1.2;
}
.cta-box {
  
  @media screen and (min-width: 641px) {
    height: 100%;
    display: flex;
    align-items: center;
  }
}
.boxes {
  display: flex;
  flex-direction: row;
  padding: 2rem;
  display: flex;
  align-items: center;
  @media screen and (max-width: 640px) {
    flex-direction: column;
  }
}

.cta-box .boxes {
  padding: 0.5rem;
}

.linkbox {
  padding: 1rem;
  margin: 0.5rem auto;
  text-align: center;
  text-transform: uppercase;
}
.box {
  display: flex;
  flex-direction: column;
  padding: 2rem;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.box:hover {
  img {
    transform: scale(1.04);
  }
}

.box:active {
  transform: scale(0.96);
}
</style>
